import React from 'react'
import { connect } from 'react-redux'
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'moment/locale/pt-br'
import '../../../css/components/react-datepicker.css';
import pt from 'date-fns/locale/pt';
import Titulo from '../../comum/Titulo';
import { alterouEmpresa } from '../../../actions/empresa/alterarEmpresaSelecionada';
import buscarFechamentosCaixa from '../../../actions/fechamento-caixa/usuario/buscarFechamentosCaixa';
import limparFechamentosCaixa from '../../../actions/fechamento-caixa/limparFechamentosCaixa';
import Autorizacao, { validaPerfis } from '../../../security/Autorizacao';
import {
  getFinanceiroAgencia,
  getFinanceiroCaixa,
  getGestorEmpresa,
  getOperadorEmpresa,
  getPerfisVendedores,
  PERFIL_ADMIN,
} from '../../../security/securityContext';
import CampoSelecionarEmpresa from '../../layout/CampoSelecionarEmpresa';
import FechamentoCaixa from './FechamentoCaixa';
import ModalFechamentoCaixa from './ModalFechamentoCaixa';
import CabecalhoRodapeTabela from '../../comum/CabecalhoRodapeTabela';
import PaginacaoFechamentoCaixa from '../PaginacaoFechamentoCaixa';
import BotoesPaginacaoFechamentoCaixa from '../BotoesPaginacaoFechamentoCaixa';
import { alterouFiltro, alterouPagina } from '../../../util/filtros';
import determinarPaginaAtual from '../../../actions/fechamento-caixa/determinarPaginaAtuaFechamentoCaixa';
import buscarFechamentoDia from '../../../actions/fechamento-caixa/usuario/buscarFechamentoDia';
import PainelFiltragem from './PainelFiltrosFechamentoCaixa';
import alterarRegistrosPorPagina from '../../../actions/fechamento-caixa/alterarRegistrosPorPaginaFechamentoCaixa';
import limparFiltroFechamentoCaixa from '../../../actions/fechamento-caixa/limparFiltroFechamentoCaixa';
import downloadParteFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/downloadParteFechamentoCaixa';

registerLocale('pt', pt);
setDefaultLocale('pt');

export const CabecalhoTabela = () => (
  <div className="vx-gp-table-header vx-gp-table-header--fechamento d-none d-lg-grid">
    <div>Data</div>
    <div>Agente</div>
    <div>Qtd. Vendas</div>
    <div>Valor Total</div>
    <div>Situação</div>
    <div>Ações</div>
  </div>
);

export const CabecalhoTabelaRelatorio = () => (
  <thead>
  <tr>
    <th scope='col'>Data</th>
    <th scope='col'>Vendedor</th>
    <th scope="col">Tarifa</th>
    <th scope="col">Desconto</th>
    <th scope="col">SubTotal</th>
    <th scope="col">Taxa embarque</th>
    <th scope="col">Impostos</th>
    <th scope="col">Comissão</th>
    <th scope="col">Líquido</th>
    <th scope="col">Agência</th>
  </tr>
  </thead>
);


export class PainelFechamentoCaixa extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      dataSelecionada: null,
      itemFechamentoSelecionado: null
    };
  }

  selecionarItemFechamento (item) {
    this.setState({
      itemFechamentoSelecionado: item
    });
  }

  limparCampos() {
    this.props.limparFechamentosCaixa();
    // this.props.limparFiltroFechamentoCaixa();
  }

  componentDidMount () {
    this.limparCampos();
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.buscarFechamentos();
      if (!validaPerfis([PERFIL_ADMIN])) {
        this.props.buscarFechamentoDia(this.props.empresaSelecionada.id)
      }
    }
  }

  componentDidUpdate (prevProps) {
    if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
      this.buscarFechamentos();
      if (!alterouPagina(this.props, prevProps)) {
        this.props.determinarPaginaAtual(1)
      }
    }
  }

  exibirTabela () {
    if ((this.props.fechamentosCaixa && this.props.fechamentosCaixa.length) || this.props.fechamentoCaixaDia) {
      return (<div id='tabela-pedidos'>
          <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoFechamentoCaixa}
                                 BotoesPaginacao={BotoesPaginacaoFechamentoCaixa}
                                 pedidos={this.props.pedidos}
                                 empresaSelecionada={this.props.empresaSelecionada}>
            <CabecalhoTabela idEmpresa={this.props.empresaSelecionada.id}/>
            <div className="lista-table">
              {this.exibirFechamentoDia()}
              {this.exibirFechamento()}
            </div>
          </CabecalhoRodapeTabela>

        </div>
      )
    }
    return (
      <div className="vx-gp-empty">
        <span className="material-icons vx-gp-empty-icon">point_of_sale</span>
        <p className="vx-gp-empty-text">Nenhum fechamento encontrado para os filtros aplicados.</p>
      </div>
    );
  }

  exibirFechamento () {
    if (this.props.fechamentosCaixa && this.props.fechamentosCaixa.length) {
      return <div className="geral">{this.props.fechamentosCaixa.map(fechamento => <FechamentoCaixa key={fechamento.id} fechamento={fechamento}/>)}</div>
    }
  }


  buscarFechamentos () {
    this.props.buscarFechamentosCaixa(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados)
  }

  downloadParte(idEmpresa, size, from) {
    return this.props.downloadParteFechamentoCaixa(idEmpresa, size, from, this.props.filtrosAdicionados)
      .then(response => response.payload.data);
  }

  executarDownload(arquivo) {
    let a = window.document.createElement('a');

    a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], { type: 'text/csv;' }));
    a.download = 'Lista de Fechamentos de Caixa.csv';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  exportarListaFechamentos() {
    let arquivo = 'Data;Nome Fantasia;Nome Agência;Agente;Quantidade de Vendas;(+) Total Tx de Serviço;(+) Total Tx de Pedágio;';

    arquivo += '(+) Total adiantamento baixado;(-) Total adiantamento lançado;(-) Total despesas;(-) Total Lançamentos a receber;(-) Total de Seguro;(-) Total imposto retido;';

    arquivo += '(-) Total seguro e imposto retido;(-) Total recebido cartão;(-) Total recebido PIX;(-) Total de cancelamentos;(+) Total recebido cartão no site;(+) Total de residual de cancelamentos;(+) Total excesso bagagem;(=) Total Tx de Embaque CEA;';
    
    arquivo += 'Valor Total de Vendas;(-) Total Comissão;(-) Total Comissão Reimpressão;(-) Total Comissão Seguro;(=) Total Deposito;CPF/CNPJ - TITULAR DO COMPROVANTE;Data Comprovante Depósito;Data/Hora da Última Atualização;Situação\n';

    let size = 10000;

    let qtd = this.props.total;
    let totalParticoes = Math.ceil(qtd / 10000);

    const processarParte = (start) => {
      if (start >= totalParticoes) {
        this.executarDownload(arquivo);
        return;
      }

      let from = start * size + 1;
      this.downloadParte(this.props.empresaSelecionada.id, size, from).then(retorno => {
        arquivo = `${arquivo}${retorno.fechamentos.map(it => {
          const nomeAgencia = it.nomeAgencia != null ? it.nomeAgencia : '';

          const dataHoraUltimoHistorico = it.ultimoHistorico != null && it.ultimoHistorico.dataHora ? it.ultimoHistorico.dataHora : null

          let valor = `"${it.dataFechamento}";"${this.props.empresaSelecionada.nomeFantasia}";"${nomeAgencia}";"${it.nomeUsuario}";"${it.quantidadeVendas}";"${it.totais.totalTaxaServico}";"${it.totais.totalPedagio}";`;

          valor += `"${it.totais.totalAdiantamentoBaixado}";"${it.totais.totalAdiantamentoLancado}";"${it.totais.totalDespesas}";"${it.totais.totalLancamentoAReceber}";"${it.totais.totalTarifaSeguro}";"${it.totais.totalImpostoRetido}";`;

          valor += `"${it.totais.totalTarifaSeguroImpostoRetido}";"${it.totais.totalRecebidoCartao}";"${it.totais.totalRecebidoPix}";"${it.totais.totalRecebidoLinkPagamento}";"${it.totais.totalCancelamento}";"${it.totais.totalRecebidoCartaoSite}";"${it.totais.totalCustoCancelamento}";"${it.totais.totalExcessoBagagem}";"${it.totais.totalTaxaEmbarqueCEA}";`

          valor += `"${it.totais.totalVendas}";"${it.totais.totalComissao}";"${it.totais.totalReimpressaoRecibo}";"${it.totais.totalComissaoSeguro}";"${it.totais.totalDeposito}";"${it.cpfCnpjTitularComprovante ? it.cpfCnpjTitularComprovante : ''}";"${it.dataComprovanteDeposito ? it.dataComprovanteDeposito : ''}";"${dataHoraUltimoHistorico}";"${it.descricaoSituacao}"`;

          return valor;

        }).join('\n')}\n`;

        processarParte(start + 1);
      });
    };

    processarParte(0);
  }


  exibirBotaoExportarLista() {
    return (
      <div style={{ textAlign: 'right', marginBottom: '12px' }}>
        <button className="vx-btn-primary"
          onClick={() => this.exportarListaFechamentos()}>
          Exportar Lista
        </button>
      </div>
    )
  }

  exibirCampoBuscaEmpresa () {
    return (<React.Fragment>
      <div className='row mb-4'>
        <div className="col-md-8">
          <CampoSelecionarEmpresa/>
        </div>
      </div>
    </React.Fragment>)
  }

  exibirFechamentoDia () {
    if (this.props.fechamentoCaixaDia) {
      return <div className="geral">
        <FechamentoCaixa fechamento={this.props.fechamentoCaixaDia} isFechamentoDia/>
      </div>
    }
  }

  exibirRelatorio () {
    if (this.props.fechamentosCaixa && this.props.fechamentosCaixa.length) {
      return <div>
        <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoFechamentoCaixa}
                               BotoesPaginacao={BotoesPaginacaoFechamentoCaixa}
                               empresaSelecionada={this.props.empresaSelecionada}>
          <div className='table-responsive '>
            <table className="table table-striped table-sm table-bordered text-center page-break" style={{ backgroundColor: '#FFF' }}>
              <CabecalhoTabelaRelatorio/>
              <tbody>
              {this.props.fechamentosCaixa.map(fechamentoCaixa =>
                <tr key={`relatorio-fechamento-${fechamentoCaixa.id}`}>
                  <td>
                    <span>{fechamentoCaixa.dataFechamento}</span>
                  </td>
                  <td>
                    <span>{fechamentoCaixa.nomeUsuario}</span>
                  </td>
                  <td>
                    <span>RS: 00.00</span>
                  </td>
                  <td>
                    <span>{fechamentoCaixa.totais.totalDesconto}</span>
                  </td>
                  <td>
                    <span>RS: 00.00</span>
                  </td>
                  <td>
                    <span>{fechamentoCaixa.totais.totalTaxaEmbarqueCEA}</span>
                  </td>
                  <td>
                    <span>{fechamentoCaixa.totais.totalImpostoRetido}</span>
                  </td>
                  <td>
                    <span>{fechamentoCaixa.totais.totalComissao}</span>
                  </td>
                <td>
                  <span>{fechamentoCaixa.totais.totalReimpressaoRecibo}</span>
                </td>
                  <td>
                    <span>RS: 00.00</span>
                  </td>
                  <td>
                    <span>RS: 00.00</span>
                  </td>
                </tr>)}
              </tbody>
            </table>
          </div>
        </CabecalhoRodapeTabela>
      </div>
    }
  }

  render () {
    return (
      <Autorizacao perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id),
        getFinanceiroAgencia(this.props.empresaSelecionada.id),
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getFinanceiroCaixa(this.props.empresaSelecionada.id),
        ...getPerfisVendedores(this.props.empresaSelecionada.id), PERFIL_ADMIN]}
        empresaSelecionada={this.props.empresaSelecionada}>
        <div className="row internas">
          <Titulo texto="Fechamento de Caixa (Usuário)" urlRetorno="/menu-fechamento-caixa"/>
          <div className="col-12 filtro-busca">
            <PainelFiltragem/>
          </div>
          <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
              {this.exibirCampoBuscaEmpresa()}
            </Autorizacao>
            {this.exibirBotaoExportarLista()}
            {this.exibirTabela()}
          </div>
        </div>
        <ModalFechamentoCaixa data={this.state.dataSelecionada} buscaFechamentos={this.buscarFechamentos.bind(this)}/>
      </Autorizacao>
    )
  }
}


export const mapStateToProps = state => (
  {
    fechamentosCaixa: state.fechamentosCaixa.fechamentos ? state.fechamentosCaixa.fechamentos : '',
    total: state.fechamentosCaixa.total ? state.fechamentosCaixa.total : 0,
    empresaSelecionada: state.empresaSelecionada ? state.empresaSelecionada : '',
    filtrosAdicionados: state.filtrosAdicionadosFechamentoCaixa ? state.filtrosAdicionadosFechamentoCaixa : '',
    paginaAtual: state.paginaAtualFechamentoCaixa ? state.paginaAtualFechamentoCaixa : '',
    registrosPorPagina: state.registrosPorPaginaFechamentoCaixa ? state.registrosPorPaginaFechamentoCaixa : '',
    fechamentoCaixaDia: state.fechamentoCaixaDia ? state.fechamentoCaixaDia : ''
  });


export default connect(mapStateToProps,
  {
    buscarFechamentosCaixa,
    limparFechamentosCaixa,
    limparFiltroFechamentoCaixa,
    buscarFechamentoDia,
    determinarPaginaAtual,
    alterarRegistrosPorPagina,
    downloadParteFechamentoCaixa
  })(PainelFechamentoCaixa)
